import { render } from "./Qianming01.vue?vue&type=template&id=24c8cd7c&scoped=true"
import script from "./Qianming01.vue?vue&type=script&lang=js"
export * from "./Qianming01.vue?vue&type=script&lang=js"

import "./Qianming01.vue?vue&type=style&index=0&id=24c8cd7c&scoped=true&lang=css"

import exportComponent from "E:\\back-to-class-master\\back-to-class-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c8cd7c"]])

export default __exports__